// A18.10 security-posture dashboard — module-local data layer. READ-ONLY
// aggregate over JIT / break-glass / fraud / moderation / points suspicions.
import { api } from '@/lib/api'

export interface SecurityPosture {
  jit: { pending: number; active_grants: number }
  break_glass: { active: number; total_30d: number }
  fraud: { open: number; total: number }
  moderation: { pending: number; total: number }
  points_suspicions: { open: number }
}

export const fetchPosture = (s?: AbortSignal) =>
  api.get<SecurityPosture>('/admin/security-posture', s ? { signal: s } : undefined)

export const SP_STR = {
  title: 'Безопасность / риск',
  desc: 'Сводка сигналов безопасности: JIT-доступ, break-glass, фрод, модерация (только чтение)',
  jit: 'JIT-доступ',
  breakGlass: 'Break-glass',
  fraud: 'Анти-фрод события',
  moderation: 'Флаги контента',
  points: 'Подозрения (баллы)',
  pending: 'Ожидают',
  activeGrants: 'Активных грантов',
  active: 'Активно',
  total30d: 'За 30д',
  open: 'Открыто',
  total: 'Всего',
  attention: 'Требует внимания',
  allClear: 'Чисто',
} as const
